
import React, { FC, memo, useEffect, useState } from "../../../lib/teact/teact";
import ConfirmDialog from "../../ui/ConfirmDialog";
import InputText from "../../ui/InputText";
import store from "../store";
import LotSelect from "../ui/lotSelect";
import MyDateInput from "../ui/myDateInput";
import { getCurDate } from "../utils/DateTimeUtils";
import { GetCurMien } from "../utils/common";

type OwnProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (param: any) => void;
}

const DialogGetParsedMessage: FC<OwnProps> = ({
    isOpen,
    onClose,
    onConfirm }) => {
    const curContact: any = store.getState().contact.currentContact;
    const [state, setState] = useState({
        fromDate: getCurDate(),
        toDate: getCurDate(),
        lenFrom: 10,
        lenTo: 15000,
        limit: 200,
        contactId: curContact?.contactId,
        mien: GetCurMien() as "BAC" | "TRUNG" | "NAM"
    })
    useEffect(() => {
        setState(prev => ({ ...prev, contactId: curContact?.contactId }))
    }, [curContact])
    return (
        <ConfirmDialog isOpen={isOpen}
            onClose={onClose}
            confirmHandler={() => {
                onConfirm(state);
                onClose();
            }}
            title="Phân tích lại tin nhắn"
        >
            {curContact ? (
                <div>
                    <div>
                        <span>Khách /chủ: {curContact.name}</span>
                    </div>
                </div>
            ) : (
                <div>
                    <span>Vui lòng chọn khách/chủ từ danh bạ trước khi thực hiện</span>
                </div>
            )}
            <div className=" form-content">
                <LotSelect value={state.mien} id="mien"
                    onChange={(e) => {
                        setState(prev => ({ ...prev, mien: e.target.value as "BAC" | "TRUNG" | "NAM" }))
                    }}
                >
                    <option value="BAC" selected={state.mien == "BAC"}>Miền Bắc</option>
                    <option value="TRUNG" selected={state.mien == "TRUNG"}>Miền Trung</option>
                    <option value="NAM" selected={state.mien == "NAM"}>Miền Nam</option>
                </LotSelect>
                <MyDateInput labelPosition="top" label="từ ngày"
                    onChange={(e) => {
                        setState(prev => ({ ...prev, fromDate: e.target.value }))
                    }} value={state.fromDate}></MyDateInput>
                <MyDateInput labelPosition="top" label="đến ngày"
                    onChange={(e) => {
                        setState(prev => ({ ...prev, toDate: e.target.value }))
                    }} value={state.toDate}></MyDateInput>
                <InputText label="độ dài từ" value={state.lenFrom}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, lenFrom: Number(e.target.value) }))
                    }
                    }
                ></InputText>
                <InputText label="độ dài đến" value={state.lenTo}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, lenTo: Number(e.target.value) }))
                    }
                    }
                ></InputText>
                <InputText label="giới hạn (số lượng tin nhắn)" value={state.limit}
                    onChange={(e) => {
                        setState(prev => ({ ...prev, limit: Number(e.target.value) }))
                    }
                    }
                ></InputText>
            </div>
        </ConfirmDialog>
    )
}

export default memo(DialogGetParsedMessage);